import cn from 'classnames';
import { Link } from '@framework/router/Next/Link';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { collectValidIssuers } from '@/creditflowresearch/ui/components/deals/DealListTable/cells/IssuersCell/helpers';
import { getIssuerRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';
import { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import linkStyles from '@creditflowresearch/uilib/styles/helpers/link.module.scss';

import styles from './issuersCell.module.scss';

const IssuersCell = ({ row: deal, maxWidth }: ICellProps & { maxWidth: number }) => {
  const issuerList = collectValidIssuers(deal);
  return (
    <span className={ cn(styles.links, linkStyles.textPrimary) } style={ { maxWidth } }>{
      issuerList.map((issuer, index, arr) => {
        const url = issuer.url || getIssuerRoute(issuer);
        return url && (
          <Tooltip
            key={ issuer.id }
            content={ issuer.name }
            maxWidth={ 500 }
            containerClassName={ styles.tooltipContainer }
          >
            <Link to={ url } className={ cn(styles.link, linkStyles.link) } stopPropagation>
              { issuer.name }
            </Link>
            { index !== arr.length - 1 && ', ' }
          </Tooltip>
        );
      })
    }
    </span>
  );
};

export default IssuersCell;
